import { render, staticRenderFns } from "./index.vue?vue&type=template&id=94a1d2a0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a1d2a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94a1d2a0')) {
      api.createRecord('94a1d2a0', component.options)
    } else {
      api.reload('94a1d2a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=94a1d2a0&scoped=true", function () {
      api.rerender('94a1d2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sfe/salesArea/components/Detail/index.vue"
export default component.exports